import {Component, ElementRef, EventEmitter, Input, Output, Renderer2, ViewChild} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {FormControl, ValidationErrors} from "@angular/forms";

@Component({
    selector: 'app-tags-input',
    templateUrl: './tags-input.component.html',
    styleUrls: ['./tags-input.component.scss'],
    standalone: false
})
export class TagsInputComponent {
  @Input() inputLabel: string = "";
  @Input() showErrorMessage: boolean = false;
  @Input() errors: ValidationErrors | null | undefined
  @Input() isRequired: boolean = false;
  @Input() disabled: boolean = false;
  @Input() tags: string[] = [];
  @Input() readonly: boolean = false;
  @Input() cssClass: string = '';
  @Input() control?: FormControl

  @Output() tagsChanged = new EventEmitter<string[] | undefined>();
  @Output() onTagRemoved = new EventEmitter<number>();
  newTag: string = "";
  activeTag: number | undefined;

  @ViewChild('tagsInput') tagsInput!: ElementRef;

  @Input() badgeColor: 'red' | 'green' | 'orange' | 'blue' | 'yellow' | 'grey' | undefined;

  constructor(private translocoService: TranslocoService, private renderer: Renderer2) {

  }

  triggerFunction(event: KeyboardEvent) {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (!this.tags) {
        this.tags = [];
      }

      if (this.newTag !== "") {
        this.tags.push(this.newTag);
        this.newTag = "";
        this.tagsChanged.emit(this.tags);
      }
    }
    if (event.key === "Backspace") {
      if (this.activeTag !== undefined) {
        this.activeTag = undefined;
        this.tags?.pop();
        this.tagsChanged.emit(this.tags);
      } else if (this.tags.length > 0 && this.newTag === "") {
        this.activeTag = this.tags.length - 1;
      }
    } else {
      this.activeTag = undefined;
    }
    this.adjustTextareaHeight();
  }

  tagRemoved(index: number) {
    this.onTagRemoved.emit(index);
  }

  adjustTextareaHeight() {
    const textArea = this.tagsInput.nativeElement;
    this.renderer.setStyle(textArea, 'height', 'auto');
    this.renderer.setStyle(textArea, 'height', textArea.scrollHeight + 'px');
  }
}
